import React from "react";
import LogicGroupEditor from "./LogicGroupEditor";
import LogicSlotEditor from "./LogicSlotEditor";

const LogicNodeEditor = ({ node, onChange, onDelete, questions, isRoot }) => {
  if (!node) return null;

  if (node.type === "GROUP") {
    return (
      <LogicGroupEditor
        node={node}
        onChange={onChange}
        onDelete={onDelete}
        questions={questions}
        isRoot={isRoot}
      />
    );
  }

  if (node.type === "SLOT") {
    return (
      <LogicSlotEditor
        node={node}
        onChange={onChange}
        onDelete={onDelete}
        questions={questions}
      />
    );
  }

  return null;
};

export default LogicNodeEditor;
